// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6cbf5b2b","821":"7c1bd405"}[chunkId] + ".chunk.js";
};